/**
 * Theme handling.
 *
 * The initial `data-theme` attribute is set by public/theme-boot.js, loaded
 * from index.html before first paint so there is no flash. This module only
 * owns *changes* made at runtime and keeps them in sync with localStorage.
 *
 * readTheme() trusting that attribute is why the boot script may not be inline:
 * the production CSP refuses inline scripts, and the only symptom would be a
 * reader's dark theme quietly reverting on every reload.
 */

export type Theme = 'light' | 'dark'

const STORAGE_KEY = 'theme'

export function readTheme(): Theme {
  if (typeof document === 'undefined') return 'light'
  const attr = document.documentElement.getAttribute('data-theme')
  return attr === 'dark' ? 'dark' : 'light'
}

export function applyTheme(theme: Theme): void {
  if (typeof document === 'undefined') return
  document.documentElement.setAttribute('data-theme', theme)
  try {
    localStorage.setItem(STORAGE_KEY, theme)
  } catch {
    /* private mode — the attribute still applies for this session */
  }
}
